import { useState } from 'react'
import * as React from 'react'
import { useSnackbar } from 'notistack'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import {
  useGqlReportNewsItemMutation,
  useReportNewsCommentMutation,
} from 'generated/graphql'
import Button from '@app.components/Button'
import useChannelError from '@app.feature/channel/hook/useChannelError'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import Radio from 'app.components/inputs/Radio'
import { mobileBreakPoint } from 'app.styled/media'

export const REPORT_REASONS = {
  ABUSIVE_WORD: '욕설/비하 발언',
  OBSCENE_POST: '음란성',
  PROMOTIONAL_CONTENT: '홍보성 콘텐츠 및 도배글',
  PERSONAL_INFO_EXPOSURE: '개인정보 노출',
  SLANDER: '특정인 비방',
  ETC: '기타',
} as const

interface ReportModalProps extends IFModalProps {
  reportedId: string
  type: 'comment' | 'newsItem'
}

const ReportModal: React.FC<ReportModalProps> = ({
  reportedId,
  onClose,
  type,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const onError = useChannelError()

  const reportNewsItemMutate = useGqlReportNewsItemMutation({
    onCompleted: () => {
      enqueueSnackbar('신고 완료되었습니다.')
    },
    onError: onError,
  })
  const reportNewsCommentMutation = useReportNewsCommentMutation({
    onCompleted: () => {
      enqueueSnackbar('신고 완료되었습니다.')
    },
    onError: onError,
  })

  const [input, setInput] = useState<string>(REPORT_REASONS.ABUSIVE_WORD)

  const handleConfirm = () => {
    if (type === 'newsItem') {
      const [mutate] = reportNewsItemMutate
      mutate({
        variables: {
          input: {
            reportedId: reportedId,
            reason: `${input}`,
          },
        },
      })
    }
    if (type === 'comment') {
      const [mutate] = reportNewsCommentMutation
      mutate({
        variables: {
          input: {
            reportedId: reportedId,
            reason: `${input}`,
          },
        },
      })
    }
    if (onClose) onClose()
  }

  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper>
        <div className="modal-header">
          <div className="header-title">
            {type === 'comment' ? '댓글' : '소식'} 신고 사유를 선택해주세요.
          </div>
          <div className="close-btn" onClick={onClose}>
            <Close />
          </div>
        </div>
        <div className="modal-sub-title">
          {Object.values(REPORT_REASONS).map((reason) => (
            <Radio
              key={reason}
              defaultChecked={reason === REPORT_REASONS.ABUSIVE_WORD}
              labelText={reason}
              labelFor={reason}
              id={reason}
              value={reason}
              onClick={() => setInput(reason)}
              name="ban-reason"
            />
          ))}
        </div>

        <div className="btn-list">
          <Button color="grey" className="btn cancle" onClick={onClose}>
            취소
          </Button>
          <Button className="btn" onClick={handleConfirm}>
            확인
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default ReportModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 450px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
  }
  .modal-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid #eeeeee;
    .header-title {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .modal-title {
    font-size: 24px;
    font-weight: 600;
  }
  .modal-sub-title {
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: 18px;
    margin: 20px 0 30px;
    width: 100%;
    font-weight: 500;
  }
  .modal-description {
    font-size: 16px;
    margin: 20px 0 30px;
    text-align: center;
  }
  .btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    .btn {
      font-size: 16px;
      padding: 13px 30px;
      &.cancle {
        background-color: #bbbbbb;
      }
    }
  }
  ${mobileBreakPoint} {
    max-width: 350px;
  }
`
